import React, { memo, ReactElement, useEffect } from 'react'
import {
  useForm,
  FormProvider,
  UseFormReturn,
  FieldValues,
  UseFormProps,
} from 'react-hook-form'

interface ISimpleFormProps<T extends FieldValues> extends UseFormProps<T> {
  onSubmit: (formValues: T) => void
  onLoad?: (formMethods: UseFormReturn<T>) => void
  onChange?: () => void
  onClick?: () => void
  children: ReactElement | ReactElement[]
  defaultValues?: any
}

function SimpleForm<T extends FieldValues>({
  children,
  onSubmit,
  onLoad,
  ...props
}: ISimpleFormProps<T>) {
  const { defaultValues, resolver, ...others } = props
  const methods = useForm<T>({
    defaultValues,
    resolver,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  })

  useEffect(() => {
    onLoad && onLoad(methods)
  }, [onLoad, methods])

  return (
    <FormProvider {...methods}>
      <form {...others} onSubmit={methods.handleSubmit(onSubmit)}>
        {children}
      </form>
    </FormProvider>
  )
}

export default memo(SimpleForm) as typeof SimpleForm
